import Home from './HomeTabPanelPage';

export default Home;
